var HttpError = function HttpError(status, data) {
  this.isFoundHttpError = true;
  this.status = status;
  this.data = data;
};

export { HttpError as default };